import { Ntext } from "components";
import React, { useState } from "react";

const list = [
  "All Articles",
  "Inside Nomba",
  "Product Updates",
  "Networking",
  "Boosting Numbers",
  "One Design",
];

const BlogCategoryFilter = ({ state, dispatch }) => {
  const [filter_open, set_filter_open] = useState(false);

  const handle_filter = payload => {
    if (payload === state.order) {
      return;
    }

    dispatch({ type: "update-order", payload });
    set_filter_open(false);
  };

  const select_category = category => {
    if (category === state.selected_category) return;
    dispatch({ type: "update-selected-category", payload: category });
  };

  const categories = [
    { name: "All", value: undefined },
    ...state.categories.map(item => ({
      name: item?.name,
      value: item?.id,
    })),
  ];
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-3">
        {categories?.map(category => (
          <div
            key={category?.value}
            className={`py-[10px] px-5 rounded-full  border-2 ${
              state.selected_category === category?.value
                ? "bg-[#FFCC00] border-[#FFCC00]"
                : "border-[#F2F2F2]"
            } cursor-pointer`}
            onClick={() => select_category(category?.value || undefined)}
          >
            <Ntext
              variant="p"
              className={`!text-[16px] !font-medium !leading-[24px] ${
                state.selected_category === category?.value
                  ? ""
                  : "!text-[#808080]"
              } `}
            >
              {category?.name}
            </Ntext>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Ntext
          variant="p"
          className="!text-[16px] !font-medium !leading-[24px] !text-[#808080]"
        >
          Sort by:
        </Ntext>
        <div
          onClick={() => set_filter_open(prev => !prev)}
          className="relative py-[10px] px-5 rounded-full  border-2 bg-[#F2F2F2] border-[#E6E6E6] flex items-center gap-1 cursor-pointer"
        >
          <Ntext
            variant="p"
            className="!text-[16px] !font-medium !leading-[24px]"
          >
            {state.order === "desc" ? "Newest" : "Oldest"}
          </Ntext>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={filter_open ? "transform rotate-180" : ""}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z"
              fill="#333333"
            />
          </svg>

          {filter_open ? (
            <div
              onClick={e => e.stopPropagation()}
              className="absolute w-full right-0 top-14 border border-[#E6E6E6] bg-white p-1 rounded-md flex flex-col gap-1"
            >
              <div
                onClick={() => handle_filter("desc")}
                className="w-full px-4 py-2 hover:bg-[#F2F2F2] rounded-sm"
              >
                <Ntext
                  variant="p"
                  className="!text-[16px] !font-medium !leading-[24px]"
                >
                  Newest
                </Ntext>
              </div>
              <div
                onClick={() => handle_filter("asc")}
                className="w-full px-4 py-2 hover:bg-[#F2F2F2] rounded-sm"
              >
                <Ntext
                  variant="p"
                  className="!text-[16px] !font-medium !leading-[24px]"
                >
                  Oldest
                </Ntext>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export { BlogCategoryFilter };
